"use client";

import CropSettingsManagement from "@/components/artwork/CropSettingsManagement";
import "./styles.scss";
import { useRouter, useSearchParams } from "next/navigation";
import { TabView, TabPanel } from "primereact/tabview";

enum AdvanceType {
  cropSettings = "crop-settings",
}

const tabTypes: { [index: number]: AdvanceType } = {
  0: AdvanceType.cropSettings,
};

const tabIndexes = {
  [AdvanceType.cropSettings]: 0,
};

const AdvancesPage = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const type = searchParams.get("type") || AdvanceType.cropSettings;

  const activeIndex = tabIndexes[type as AdvanceType];

  const onTabChange = (index: number) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("type", tabTypes[index]);
    router.push(`?${params.toString()}`);
  };

  return (
    <div className="flex h-full w-full flex-col p-4">
      <h1 className="text-xl font-bold text-gray-800">Advances</h1>
      <div className="flex flex-1 flex-col overflow-auto">
        <TabView
          className="tab-view flex h-full flex-1 flex-col"
          activeIndex={activeIndex}
          onTabChange={(event) => onTabChange(event.index)}
        >
          <TabPanel header="Crop settings">
            <div className="flex h-full w-full overflow-auto">
              <CropSettingsManagement />
            </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default AdvancesPage;
